<template>
  <form @submit.prevent="submit">
    <dt-modal v-model="isVisible">
      <div slot="header">
        <h4 class="modal-title">
          {{ confirmTitle }}
        </h4>
      </div>
      <div slot="body">
        <div class="row">
          <div class="form-group col-md-12">
            <p>{{ confirmQuestion }}</p>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button
          type="button"
          class="btn btn-default"
          @click="close()"
        >{{ confirmNoAction }}</button>
        <button
          type="submit"
          class="btn btn-primary"
          :class="{'cleverButton':isClever}"
        >{{ confirmAction }}</button>
      </div>
    </dt-modal>
  </form>
</template>
<script>
import DtModal from '@/components/utilities/modal/dt-modal.vue'
import globals from '@/plugins/globals.js'
export default {
  name: 'dialog-confirm-calibrate',
  components: {
    DtModal
  },
  props: {
    value: Boolean,
    confirmTitle: String,
    confirmNoAction: String,
    confirmAction: String,
    confirmQuestion: String
  },
  computed: {
    isVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    isClever: {
      get() {
        let _isClever = globals.isClever()
        return _isClever
      }
    }
  },
  methods: {
    close() {
      this.$emit('closing')
    },
    submit() {
      this.$emit('proceed', this.value)
    }
  }
}
</script>
<style lang="scss" scoped>
.cleverButton {
  background-color: #EAAA00;
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/utilities/modal/dt-confirm.vue